import React from 'react'
import { Route, Redirect, Switch } from 'react-router-dom'

// Config
import { ACCOUNT_PATH, PASSWORD_PATH, REGISTER_PATH, SIGN_IN_PATH, SITE_PATH, SITES_PATH } from 'config'


// Components
import AccountLayout from 'components/account/layout'
import Password from 'components/auth/password/password'
import Register from 'components/auth/register/register'
import SignIn from 'components/auth/sign-in/sign-in'
import Site from 'components/sites/site'
import SiteForm from 'components/sites/wizard'
import Sites from 'components/sites/sites'
import AnonRoute from './anon-route'
import PrivateRoute from './private-route'
import RouteStateSetter from 'components/app/route-state-setter'

export default () => {
  return (
    <main className="main-wrapper container">
      <Route path="/:page?/:siteId?/:dir?/:queueId?" component={ RouteStateSetter } />
      <Switch>
        <AnonRoute component={ Password } path={ PASSWORD_PATH } />
        <AnonRoute component={ Register } path={ REGISTER_PATH } />
        <AnonRoute component={ SignIn } path={ SIGN_IN_PATH } />

        <PrivateRoute exact component={ Sites } path={ SITES_PATH } />
        <PrivateRoute component={ SiteForm } path={ `${SITES_PATH}/add` } />

        <PrivateRoute path={ SITE_PATH } component={ Site } />

        <PrivateRoute component={ AccountLayout } path={ ACCOUNT_PATH } />

        <Redirect to={ SITES_PATH } />
      </Switch>
    </main>
  )
}




// WEBPACK FOOTER //
// ./src/components/app/app.js